import styled from 'styled-components';

const Hamburger = styled.img`
  height: 14px;
  width: 21px;
`;

export default Hamburger;
